var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIconPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52879 1.50256C6.65586 1.50256 7.58048 2.42719 7.58048 3.55425V5.60594H3.4771V3.55425C3.4771 2.42719 4.40173 1.50256 5.52879 1.50256ZM8.94828 5.60594V3.55425C8.94828 1.67217 7.41088 0.134766 5.52879 0.134766C3.64671 0.134766 2.10931 1.67217 2.10931 3.55425V5.60594H1.42541C1.06265 5.60594 0.714746 5.75005 0.458235 6.00656C0.201724 6.26307 0.0576172 6.61098 0.0576172 6.97374V12.4449C0.0576172 12.8077 0.201724 13.1556 0.458235 13.4121C0.714746 13.6686 1.06265 13.8127 1.42541 13.8127H9.63218C9.99494 13.8127 10.3428 13.6686 10.5994 13.4121C10.8559 13.1556 11 12.8077 11 12.4449V6.97374C11 6.61098 10.8559 6.26307 10.5994 6.00656C10.3428 5.75005 9.99494 5.60594 9.63218 5.60594H8.94828ZM1.42541 6.97374H9.63218V12.4449H1.42541V6.97374Z",
    fill: "#572148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIconPurple);
export default __webpack_public_path__ + "static/media/lock-icon-purple.128dd03163909e14633c7ff1c5c9955f.svg";
export { ForwardRef as ReactComponent };